export const DYDX_TOKEN_ADDRESS = '0x92D6C1e31e14520e676a687F0a93788B716BEff5';

export const WETH_DYDX_TOKEN_ADDRESS = '0x46b2DeAe6eFf3011008EA27EA36b7c27255ddFA9';

export const DYDX_TOKEN = {
  shortDecimals: 8,
  decimals: 18,
  symbol: 'DYDX',
  name: 'dydx',
  denom: 'adydx',
};

export const USDC_TOKEN = {
  shortDecimals: 6,
  decimals: 6,
  symbol: 'USDC',
  name: 'USDC',
  denom: 'ibc/8E27BA2D5493AF5636760E354E46004562C46AB7EC0CC4C1CA14E9E20E2545B5',
};
